export const LANGUAGES = {
    en: 'en',
    id: 'id'
}
export const DEFAULT_LANGUAGE = LANGUAGES.en;